// Extend String and Array prototypes with custom methods for older browsers

declare global {
  interface String {
    capitalize(): string;
  }

  interface Array<T> {
    swap(x: number, y: number): Array<T>;
  }
}

if (!String.prototype.capitalize) {
  String.prototype.capitalize = function (): string {
    return this.charAt(0).toUpperCase() + this.slice(1);
  };
}

if (!String.prototype.includes) {
  String.prototype.includes = function (str: string): boolean {
    let returnValue = false;

    if (this.indexOf(str) !== -1) {
      returnValue = true;
    }

    return returnValue;
  };
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString: string, position?: number): boolean {
    const newPosition = position || 0;

    return this.indexOf(searchString, newPosition) === newPosition;
  };
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (searchString: string, position?: number): boolean {
    const subjectString = this.toString();
    let pos = position;
    if (
      typeof pos !== 'number' ||
      !Number.isFinite(pos) ||
      Math.floor(pos) !== pos ||
      pos > subjectString.length
    ) {
      pos = subjectString.length;
    }
    pos -= searchString.length;
    const lastIndex = subjectString.indexOf(searchString, pos);

    return lastIndex !== -1 && lastIndex === pos;
  };
}

if (!Array.prototype.swap) {
  Array.prototype.swap = function <T>(this: T[], x: number, y: number): T[] {
    const b = this[x];
    this[x] = this[y];
    this[y] = b;

    return this;
  };
}

if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value<T>(this: T[], predicate: (value: T, index: number, obj: T[]) => boolean): T | undefined {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      const o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      const len = o.length >>> 0; // eslint-disable-line no-bitwise

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      const argThis = arguments[1]; // eslint-disable-line prefer-rest-params

      // 5. Let k be 0.
      let k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        const kValue = o[k];
        if (predicate.call(argThis, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    },
    configurable: true,
    writable: true
  });
}

export {};
